import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import { Button } from 'src/components/common';

export class FilterAction extends PureComponent {
  render() {
    const {
      search, excel, reset, importData, loadingExcel, deletes
    } = this.props.actions;
    return (
      <>
        {search
          && (
            <Button
              onClick={search}
              type="primary submit"
            >
              <div className="content-btn">
                <span className="name"><Icon type="search" /> Tìm kiếm</span>
              </div>
            </Button>
          )}
        {excel
          && (
            <Button
              className="heading-button-export-excel"
              icon="file-excel"
              loading={loadingExcel}
              onClick={excel}
            >
              Xuất excel
            </Button>
          )}
        {deletes && deletes.maThon && deletes.isHiddenBt
          && (
            <Button
              onClick={deletes.deleteDuLieu}
              type="danger submit"
            >
              <span className="name"><Icon type="delete" /> Xóa dữ liệu</span>
            </Button>
          )}
        {reset
          && (
            <Button onClick={reset}>
              <div className="content-btn">
                <span className="name"><Icon type="reload" /> Làm mới</span>
              </div>
            </Button>
          )}
        {importData
          && (
            <Button onClick={importData}>
              <div className="content-btn">
                <span className="name"><Icon type="import" /> Import dữ liệu</span>
              </div>
            </Button>
          )}
      </>
    );
  }
}

FilterAction.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired
};

export default FilterAction;
